import type { GroupNode, NodeData } from "@repo/shared/workflow";
import type { FC } from "react";

interface GroupNodeEditorProps {
  node: GroupNode;
  onChange: (key: string, value: any) => void;
}

export const GroupNodeEditor: FC<GroupNodeEditorProps> = ({
  node,
  onChange,
}) => {
  return <div className="space-y-4">This is the group node editor</div>;
};
